// Components==============
import { motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import { GrowthPortfolioContext } from 'pages/Growth/GrowthPortfolio/GrowthPortfolio';
import React, { useContext } from 'react';
import { interactiveScale } from 'utilities/FramerAnimations';
import './People.module.scss';
// =========================

const parent = {
  visible: {
    transition: { staggerChildren: 0.15, delayChildren: 0.5 },
  },
  invisible: {},
};

const child = {
  visible: { opacity: 1 },
  invisible: { opacity: 0 },
};

export default function People() {
  const translate = useTranslate();

  const people = useRedux((state) =>
    state.authentication?.user.person_data.map(
      (p) => state.people?.entities.byId[p.id]
    )
  );

  const orderedPeople = [people?.[1], people?.[0], people?.[2]];

  const { setSelected } = useContext(GrowthPortfolioContext);

  return (
    <div styleName="box">
      <div styleName="wrapper">
        <motion.div
          {...interactiveScale}
          styleName="people"
          onClick={() => setSelected('reflection.terms.inspiration')}
        >
          <motion.div variants={parent} initial="invisible" animate="visible">
            {orderedPeople?.map((person, i) => (
              <motion.img
                src={`/storage/${person?.image}`}
                alt={person?.name}
                key={person?.id}
                styleName={`person p-${i}`}
                variants={child}
              />
            ))}
          </motion.div>
        </motion.div>
        <h3>{translate('reflection.terms.inspiration')}</h3>
      </div>
    </div>
  );
}
